import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import { AiChangeType } from '../../../../../../../ai';
import { FillInBlankAddQuestionStrategy } from './fill-in-blank-add.strategy';
import { FillInBlankDeleteQuestionStrategy } from './fill-in-blank-delete.strategy';
import { FillInBlankUpdateQuestionStrategy } from './fill-in-blank-update.strategy';
export var FillInBlankAiChangeStrategyFactory = /*#__PURE__*/function () {
  function FillInBlankAiChangeStrategyFactory() {
    _classCallCheck(this, FillInBlankAiChangeStrategyFactory);
  }

  _createClass(FillInBlankAiChangeStrategyFactory, null, [{
    key: "create",
    value: function create(context) {
      switch (context.changeType) {
        case AiChangeType.Add:
          return new FillInBlankAddQuestionStrategy(context);

        case AiChangeType.Update:
          return new FillInBlankUpdateQuestionStrategy(context);

        case AiChangeType.Delete:
          return new FillInBlankDeleteQuestionStrategy(context);

        default:
          throw new Error('Unsupported change type for fill-in-blank');
      }
    }
  }]);

  return FillInBlankAiChangeStrategyFactory;
}();